/**
 * First bank-transfer click must persist the same snapshot as a successful retry.
 * Self-compose 2×OW often saves outbound before inbound LDS id exists; the second
 * click then refreshes. Detect that incomplete row and refresh before POST.
 */

function asObject(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : null;
}

function firstNonEmptyString(...candidates) {
  for (const value of candidates) {
    if (value == null) continue;
    const s = String(value).trim();
    if (s) return s;
  }
  return null;
}

export function isSelfComposeInboundMissing(orderRow) {
  const row = asObject(orderRow);
  if (!row) return false;
  const flights = asObject(row.flights) || {};
  const inbound =
    asObject(flights.self_compose_inbound) ||
    asObject(flights.selfComposeInbound);
  const inboundId = firstNonEmptyString(
    row.self_compose_inbound_lds_order_id,
    row.inbound_lds_order_id,
    inbound?.ldsorderid,
    inbound?.ldsOrderId,
    inbound?.id
  );
  const tripToken = String(
    flights.trip_type || flights.triptype || flights.TripType || row.deal_type_extra || ""
  )
    .replace(/[\s_-]/g, "")
    .toUpperCase();
  const markedTwoWay =
    tripToken.includes("2ONEWAY") ||
    inbound != null ||
    Boolean(row.self_compose_inbound_lds_order_id);
  if (!markedTwoWay) return false;
  return inboundId == null;
}

export function shouldRefreshDraftBeforeBankTransfer({
  orderRow,
  uiTotalIls,
} = {}) {
  if (isSelfComposeInboundMissing(orderRow)) return true;
  const server = Number(orderRow?.total_price || 0);
  const ui = Number(uiTotalIls || 0);
  return ui > 0 && server > 0 && Math.abs(ui - server) > 1;
}

export function shouldRetryBankTransferAfterFailure(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (String(payload.status || "").toLowerCase() === "ok") return false;
  const err = String(payload.error || payload.reason || "");
  return err === "lds_proposal_failed" || err.includes("lds_proposal");
}
